import { render, staticRenderFns } from "./SelectTaskDefectField.vue?vue&type=template&id=8d6bbdbe"
import script from "./SelectTaskDefectField.vue?vue&type=script&lang=js"
export * from "./SelectTaskDefectField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports